import React from 'react';
import { Flex, HStack, IconButton, Button, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, DrawerFooter, useDisclosure, Badge, Box } from '@chakra-ui/react';
import { SettingsIcon, CloseIcon } from '@chakra-ui/icons';

export default function FiltersBar({ children, filtersContent, onApply, onReset, activeCount = 0, ...props }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleApply = () => {
    if (onApply) onApply();
    onClose();
  };
  const handleReset = () => {
    if (onReset) onReset();
  };

  return (
    <>
      <Box bg="gray.50" border="1px solid" borderColor="gray.200" borderRadius="xl" px={{ base: 3, md: 4 }} py={{ base: 2, md: 3 }} mb={3}>
        <Flex align="center" justify="space-between" wrap="wrap" gap={4} {...props}>
          <Box display={{ base: 'none', md: 'block' }} flex="1 1 auto">
            <HStack spacing={3} wrap="wrap">
              {children}
            </HStack>
          </Box>
          <HStack spacing={2} display={{ base: 'flex', md: 'none' }}>
            <IconButton aria-label="Open filters" icon={<SettingsIcon />} onClick={onOpen} variant="outline" borderRadius="full" />
            {activeCount > 0 && (
              <Badge colorScheme="brand" borderRadius="full" px={2}>{activeCount}</Badge>
            )}
          </HStack>
        </Flex>
      </Box>
      <Box h="1px" bg="gray.200" mb={6} />

      <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} size="full">
        <DrawerOverlay />
        <DrawerContent borderTopRadius="xl">
          <DrawerHeader display="flex" alignItems="center" justifyContent="space-between">
            Filters
            <IconButton aria-label="Close" icon={<CloseIcon />} onClick={onClose} variant="ghost" />
          </DrawerHeader>
          <DrawerBody>
            {filtersContent || (
              <HStack spacing={3} wrap="wrap">
                {children}
              </HStack>
            )}
          </DrawerBody>
          <DrawerFooter gap={3}>
            <Button variant="ghost" onClick={handleReset}>Reset</Button>
            <Button colorScheme="brand" onClick={handleApply}>Apply</Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}


